module.exports = __webpack_public_path__ + "static/media/29COICT3.6efb609c.jpg";